import { BUYER_TYPE, PAGE_LIMIT, PAGE_NOTIFICATION_LIMIT } from '../app-constant';
import DateTimeUtils from '../utils/datetime';

const toDay = new Date();
const firstDayInYear = new Date(toDay.getFullYear(), 0, 1);

export default {
  startDateSynchronized: localStorage.getItem('startDateSynchronized') || '',

  appLoaded: null,
  appLoading: true,
  firstLoaded: false,
  activeTab: 'TAB_MAIN',
  appNavbarDisplay: true,

  detailsInvoice: new Map(),
  inProgressErrorInvoices: {},
  recentImportedInvoices: [],
  inProgressInvoiceList: [],

  selectedInvoices: new Set(),
  selectedDirectories: [],
  selectedSuspectInvoices: false,
  selectedInvoiceType: null,
  selectedTaxAgencyStatus: null,
  selectedCompany: null,

  activeDirectory: null,
  checkAll: false,
  activeInvoice: {},

  invoiceBase64File: null,
  invoiceFileLoading: true,
  detailsInvoiceLoading: false,
  downloadInvoiceLoading: false,
  downloadExcelLoading: false,
  downloadXmlBcssLoading: false,

  invoiceList: [],
  lastFetchedInvoiceList: [],
  invoiceListLoading: false,
  loadMoreInvoiceLoading: false,
  invoiceListPageInfo: {
    total: 0,
    current_page: 1,
    current_limit: PAGE_LIMIT,
  },

  // invoiceViewerData: [],
  // invoiceViewerLoading: false

  customerList: [],
  lastFetchedCustomerList: [],
  customerListLoading: true,

  vendorList: [],
  lastFetchedVendorList: [],
  vendorListLoading: true,

  appDirectory: [],
  appDirectoryList: [],

  invoicesStatistic: {
    count_new_invoices: 0,
    count_warning_invoices: 0,
  },
  currentStatistic: {
    revenue: 0,
    expense: 0,
    benefit: 0,
  },
  statusStatistic: {
    draft: 0,
    failed: 0,
    issuing: 0,
  },
  appStatistics: {
    tags: [],
  },

  directoryTagFilterText: '',
  invoiceFilter: {
    text: '',
    type: 'ALL',
  },
  invoiceCount: {},
  tags: JSON.parse(localStorage.getItem('tags')) || [],
  currentTagAccessList: null,

  autoCompleteSearchResult: {
    isMultiSelect: false,
    activeIndex: -1,
    selectedItems: [],
    collection: [],
    renderItemText: item => item.text,
  },

  globalSearchResult: {
    tabIndex: -1,
    activeIndex: -1,
    selectedItems: [],
    collection: [],
    renderItemText: item => item.text,
  },

  invoiceGlobalSearchParams: {
    start_date_default: DateTimeUtils.formatDate(firstDayInYear, 'YYYY-MM-DD'),
    start_date: DateTimeUtils.formatDate(firstDayInYear, 'YYYY-MM-DD'),
    end_date_default: DateTimeUtils.formatDate(toDay, 'YYYY-MM-DD'),
    end_date: DateTimeUtils.formatDate(toDay, 'YYYY-MM-DD'),
    period: 'MONTH',
    statistics: undefined,
    currency: 'VND',
  },

  invoiceListEnum: JSON.parse(localStorage.getItem('list-enum')) || {
    InvoiceTypeEnum: [],
    InvoiceStatusEnum: [],
    CurrencyCodeEnum: [],
    PaymentMethodEnum: [],
    IdentifyTypeEnum: [],
    InvoiceLineTypeEnum: [],
    PaymentStatusEnum: [],
    BuyerTypeEnum: [],
    InvoiceAnnoucementStatus: [],
    TaxExchangeStatus: [],
    InvoiceColsEnum: [],
    list_wtm_images: [],
    invoice_common_code: [],
  },

  sellerSettingList: JSON.parse(localStorage.getItem('seller-setting-list')) || {
    qty_rate__settings: [],
    on_detail_invoice__settings: [],
    on_invoice__settings: [],
    seprator__settings: [],
    separator_note: '',
    inv_col_setting: '',
    invoice_fields_form_create: '',
    list_unit_name: [],
    buyer_type_recommended: BUYER_TYPE.ENTERPRISE,
    list_product_name: [],
  },

  activeAnnouncementLines: JSON.parse(localStorage.getItem('active-announcement-lines')) || {
    list_invoice_type: [],
    list_template_code: {},
    list_common_code: {},
    list_template_announcement: {},
  },

  invoice_common_code: JSON.parse(localStorage.getItem('invoice_common_code')) || [],

  notifications: {
    data: [],
    page_info: {
      total: 0,
      current_page: 1,
      current_limit: PAGE_NOTIFICATION_LIMIT,
    },
  },
  unreadNotifications: {
    data: [],
    page_info: {
      total: 0,
      current_page: 1,
      current_limit: PAGE_NOTIFICATION_LIMIT,
    },
  },
  notificationsLoading: false,

  totalInvoices: JSON.parse(localStorage.getItem('totalInvoices')) || {
    vat_payable: 0,
    receivable_debt: 0,
    debt: 0,
  },
  companyMarked: {
    id: null,
    company_name: '',
    name: '',
    address: '',
    tax_code: '',
    latest_emails: '',
  },
  checkValid: null,
};



// WEBPACK FOOTER //
// ./src/store/state.js